export type ModuleFormSource =
  (typeof ModuleFormSource)[keyof typeof ModuleFormSource];

/**
 * Enum che identifica l'ambiente sorgente del modulo,
 * viene utilizzato per gestirela visualizzazione del link
 * alla sezione condivisa esterna (presente solo in FO)
 */
export const ModuleFormSource = {
  BACKOFFICE: 'BACKOFFICE',
  FRONTOFFICE: 'FRONTOFFICE',
  ADMIN: 'ADMIN',
} as const;
